import { jsx as _jsx } from "react/jsx-runtime";
import styles from './FooterLanguages.module.scss';
import cx from 'classnames';
export const FooterLanguages = ({ languages, langId, isMobile, isMobileFooterDesignUpdate, onClick }) => (_jsx("div", { className: `${styles['footer__language']}`, children: _jsx("div", { className: `${styles['footer__language-listitem']}`, children: languages?.map((language) => {
            const isActive = langId === language?.languageId;
            const desktopClass = cx({
                [styles['footer_language-button-active']]: isActive
            });
            const mobileClass = cx({
                [styles['footer_language-button-active']]: isActive && !isMobileFooterDesignUpdate,
                [styles['footer_language-button-mobile-active-mobile']]: isActive && isMobileFooterDesignUpdate,
                [styles['footer_language-button-inactive-mobile']]: !isActive && isMobileFooterDesignUpdate
            });
            const mobileClassInital = cx({
                [styles['footer__language-button-mobile']]: isMobileFooterDesignUpdate,
                [styles['footer__language-button']]: !isMobileFooterDesignUpdate
            });
            const baseClass = 'exclude-global';
            const desktopClassName = `${baseClass} ${styles['footer__language-button']} ${desktopClass}`;
            const mobileClassName = `${baseClass} ${mobileClassInital} ${mobileClass}`;
            const buttonClass = isMobile ? mobileClassName : desktopClassName;
            return (_jsx("a", { href: language.href, className: buttonClass, "aria-label": language.nativeDescriptionString, onClick: (e) => (onClick ? onClick(e, language) : void 0), children: language.nativeDescriptionString }, language.localeName));
        }) }) }));
